import _ from 'lodash'
import { store } from 'src/App'
import { startLoading, stopLoading } from 'src/redux/slices/loading'
import {
  setInitialPreview,
  setVideoState,
  startLoading as startELearnLoading,
  stopLoading as stopELearnLoading,
} from 'src/redux/slices/eLearning/learning'
import {
  checkELearningConnection,
  getCourseLessonLearning,
  getCourseLogLearnerPerLesson,
  postCourseLogLearnerPerLesson,
  putCourseLogLearner,
  putCourseLogLearnerPerLesson,
  updateELearningConnection,
} from 'src/services/eLearning/learning'
import { openDialog, openErrorDialog } from 'src/redux/slices/alertDialog'
import {
  COURSE_TYPE,
  E_LEARNING_LEARNER_LOG_RESULT,
  MODULE_TYPE,
} from 'src/constants/eLearning'
import {
  handlePutLogLearnerPerLesson,
  removeModuleData,
} from 'src/redux/slices/eLearning/learning/events'
import { EMBED_TYPE } from './model'
import handleTimeSpentLogData from './handler/handleTimeSpentLogData'

export const handleInitLearning = (socketId, uuidProps) => async (dispatch) => {
  const { uuid, batchUuid } = uuidProps

  if (_.isEmpty(socketId)) return

  // general no batch uuid
  if (_.isEmpty(batchUuid)) {
    await dispatch(handleInitialPreview(uuidProps))
  } else {
    // for oic
    // check validate first
    const { isValidate } = getLearningState()
    if (!isValidate) {
      dispatch(
        openDialog({
          isCloseDialog: false,
          iconType: 'error',
          title: 'กรุณายืนยันตัวตนก่อนเข้าเรียน',
          message: ['กรุณาถ่ายรูปหน้าตรงของคุณ เพื่อยืนยันตัวตนก่อนเข้าเรียน'],
          buttonRight: {
            label: 'ตกลง',
            handleClick: () =>
              (window.location.href = `/e-learning/course/${uuid}`),
          },
        })
      )
      dispatch(stopLoading())
      return
    }

    // check connection
    const payload = { socketId, eLearningCourseBatchUuid: batchUuid }
    dispatch(checkELearningConnection(payload))
    await dispatch(handleInitialPreview(uuidProps))
  }
}

export const handleSocketResponse =
  (res, socket, uuidProps, dialogProps) => (dispatch) => {
    console.log('socket res', socket.id, res)
    const { setAlertDialog, setSocketDialog } = dialogProps
    const previousPath = `/e-learning/course/${uuidProps.uuid}`
    if (socket.id === res.connectedId && res.hasConnected) {
      if (!res.newSocketId) {
        dispatch(handleInitialPreview(uuidProps))
      }
    } else {
      setSocketDialog((props) => ({
        ...props,
        isDialogOpen: true,
        title: 'มีการเรียนคลาสนี้อยู่แล้ว',
        message: [
          'มีการเรียนคลาสนี้อยู่ในอุปกรณ์อื่น',
          'ต้องการเปลี่ยนมาใช้งานอุปกรณ์นี้หรือไม่?',
        ],
        buttonLeft: {
          label: 'ออกจากหน้านี้',
          handleClick: () => (window.location.href = previousPath),
        },
        buttonRight: {
          label: 'ใช้งานอุปกรณ์นี้',
          handleClick: () =>
            dispatch(handleStayOnPage(socket, uuidProps, setSocketDialog)),
        },
      }))
    }

    if (res.isForceDisconnect) {
      dispatch(setVideoState({ playing: false, isForceDisconnect: true }))
      setAlertDialog((prev) => ({ ...prev, isDialogOpen: false }))
      setSocketDialog((prev) => ({
        ...prev,
        isDialogOpen: true,
        title: 'พบการเข้าสู่ระบบใหม่',
        message: ['พบการเข้าสู่ระบบใหม่ ระบบจะนำคุณออกจากหน้านี้'],
        buttonLeft: {},
        buttonRight: {
          label: 'ตกลง',
          handleClick: () => (window.location.href = previousPath),
        },
      }))

      setTimeout(() => {
        window.location.href = previousPath
      }, 5000)
    }
  }

export const handleStayOnPage =
  (socket, uuidProps, setSocketDialog) => async (dispatch) => {
    const payload = {
      newSocketId: socket.id,
      eLearningCourseBatchUuid: uuidProps.batchUuid,
    }
    await dispatch(updateELearningConnection(payload))
    setSocketDialog((prev) => ({ ...prev, isDialogOpen: false }))
    await dispatch(handleInitialPreview(uuidProps))
  }

export const getLearningState = () => {
  return store.getState().eLearningLearning
}

export const handleIsOic = () => {
  const courseType = _.get(getLearningState().course, 'courseType', '')
  return courseType === COURSE_TYPE.OIC
}

export const handleUpdateLog = () => (dispatch) => {
  const { isCourseCompleted, eLearningCourseBatchLearner } = getLearningState()
  if (isCourseCompleted || _.isEmpty(eLearningCourseBatchLearner)) return
  dispatch(putCourseLogLearner({ eLearningCourseBatchLearner }))
}

export const handleInitialPreview = (uuidProps) => async (dispatch) => {
  const { uuid, batchUuid } = uuidProps

  dispatch(startLoading())
  dispatch(startELearnLoading())
  const response = await dispatch(getCourseLessonLearning({ uuid, batchUuid }))
  if (_.isNil(response.error)) {
    const data = _.get(response.payload, 'data', {})
    const eLearningCourseBatchLearner = {
      id: _.get(data, 'eLearningCourseBatchLearner.id', ''),
      uuid: _.get(data, 'eLearningCourseBatchLearner.uuid', ''),
    }
    const batchLearnerUuid = _.get(eLearningCourseBatchLearner, 'uuid', '')
    const resLog = await dispatch(
      getCourseLogLearnerPerLesson(batchLearnerUuid)
    )
    const dataLogs = _.get(resLog.payload, 'data', [])
    if (dataLogs.length === 0) {
      const resCreateLog = await dispatch(
        postCourseLogLearnerPerLesson({ eLearningCourseBatchLearner })
      )
      dataLogs.concat(_.get(resCreateLog.payload, 'data', []))
    }

    dispatch(setInitialPreview({ ...data, logs: dataLogs }))

    await handleCheckComplete()
  } else {
    const constraints = _.get(response.meta.response, 'data.constraints', {})
    dispatch(
      openErrorDialog({
        title: _.get(constraints, 'title', ''),
        message: [_.get(constraints, 'value', '')],
        buttonRight: {
          handleClick: () =>
            (window.location.href = `/e-learning/course/${uuid}`),
        },
      })
    )
  }
  dispatch(stopLoading())
  dispatch(stopELearnLoading())
}

export const handleCheckComplete = async () => {
  const {
    eLearningCourseBatchLearner,
    logLearnerPerLessonList,
    isCourseCompleted,
  } = store.getState().eLearningLearning

  if (isCourseCompleted) return

  const payload = {
    eLearningCourseBatchLearner,
    logLearnerPerLessonList: removeModuleData(logLearnerPerLessonList),
  }
  await store.dispatch(putCourseLogLearnerPerLesson(payload))
}

export const handleHtmlLink = (type, value) => {
  if (type === EMBED_TYPE.HTML) {
    const strArr = value?.split(' ') || []
    const src = strArr.find((word) => word?.includes('src'))
    if (typeof src === 'string') {
      return src?.replace('src="', '').replace('"', '')
    } else return ''
  }
}

export const handleUpdateLogPerLesson = (isVideoEnd) => async (dispatch) => {
  const {
    selectedLesson,
    eLearningCourseBatchLearner,
    logLearnerPerLessonList,
  } = getLearningState()
  const eLearningLessonRefModule = _.get(
    selectedLesson,
    'eLearningLessonRefModule',
    {}
  )
  const data = handleLogModuleData(selectedLesson, isVideoEnd)
  const timeSpentLog = handleTimeSpentLogData(data.percent)
  const body = {
    eLearningCourseBatchLearner,
    eLearningLessonRefModule,
    logLearnerPerLessonUuid: _.get(selectedLesson, 'logUuid', ''),
    data,
    logLearnerPerLessonList,
    timeSpentLog,
  }
  await dispatch(handlePutLogLearnerPerLesson(body))
}

export const handleLogModuleData = (selectedLesson, isVideoEnd) => {
  const type = _.get(selectedLesson, 'moduleType', '')
  const percent = _.get(selectedLesson, 'progress', 0)
  const result = handleLogResult(selectedLesson)
  const defaultData = { percent, result }
  switch (type) {
    case MODULE_TYPE.EMBED_CONTENT: {
      const duration = _.get(selectedLesson, 'videoState.playedSeconds', 0) || 0
      if (isVideoEnd) {
        return {
          percent: 100,
          result: E_LEARNING_LEARNER_LOG_RESULT.COMPLETE,
          duration: _.get(selectedLesson, 'duration', duration),
          playedPercent: 100,
        }
      } else {
        const playedPercent = _.get(selectedLesson, 'playedPercent', 0)
        return {
          ...defaultData,
          duration,
          playedPercent: percent > playedPercent ? percent : playedPercent,
        }
      }
    }
    case MODULE_TYPE.UPLOAD_FILE: {
      const files = _.get(selectedLesson, 'fileList', [])
        .map((file) => ({ uuid: file.uuid, percent: file.process }))
        .map((file) => ({ ...file, result: handleLogResult(file) }))
      return { ...defaultData, files }
    }
    case MODULE_TYPE.LINK_TO:
      return defaultData
    default:
      return defaultData
  }
}

export const handleLogResult = (selectedLesson) => {
  const percent = _.get(
    selectedLesson,
    'progress',
    _.get(selectedLesson, 'percent', 0)
  )
  const oldResult = _.get(selectedLesson, 'result', '')
  const hasCompleted = oldResult === E_LEARNING_LEARNER_LOG_RESULT.COMPLETE
  if (hasCompleted) return E_LEARNING_LEARNER_LOG_RESULT.COMPLETE
  if (percent === 0) return E_LEARNING_LEARNER_LOG_RESULT.PENDING
  if (percent === 100) return E_LEARNING_LEARNER_LOG_RESULT.COMPLETE
  else return E_LEARNING_LEARNER_LOG_RESULT.INPROGRESS
}

export const detectUsableBrowser = () => {
  const ua = navigator.userAgent

  const isFirefox = ua.includes('Firefox')
  const isSafari =
    ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('Chromium')
  const isEdge = ua.includes('Edg')
  const isOpera = ua.includes('OPR')
  const isAndroidOEMBrowser =
    /SamsungBrowser|MiuiBrowser|MQQBrowser|VivoBrowser|HeyTapBrowser|HuaweiBrowser|OPPOBrowser|UCBrowser|QQBrowser/i.test(
      ua
    )
  const isVivaldi = ua.includes('Vivaldi')
  const isBrave = navigator.brave
  const isInAppBrowser = /Line|FBAV|FBAN|Instagram|TikTok/i.test(ua)
  const isChrome =
    ua.includes('Chrome') &&
    !isEdge &&
    !isOpera &&
    !isBrave &&
    !isAndroidOEMBrowser &&
    !isVivaldi &&
    !isInAppBrowser &&
    !ua.includes('DuckDuckGo')

  const isSupport = isFirefox || isSafari || isEdge || isChrome

  return isSupport
}
